/**
 * Native replacement for lodash/fp `pick`. Returns a new object composed of the
 * given `keys` that are present in `obj`; absent keys are omitted (matching
 * lodash). A nullish `obj` yields an empty object (matching lodash).
 */
export default function pick<T extends object, K extends keyof T>(
    obj: T | null | undefined,
    keys: readonly K[],
): Pick<T, K> {
    const result = {} as Pick<T, K>;
    if (obj == null) return result;
    keys.forEach(key => {
        if (key in obj) {
            result[key] = obj[key];
        }
    });
    return result;
}
